
  module.exports =
  {

    form:
    {

      _init: function ()
      {

        this.onChangeService()

        this.onChequeTerms()

        this.onMiFiTerms()

        this.onContinue()

        this.onBack()
     
      },

      onChangeService: function ()
      {

        $('.js-service').not('.js-ignore').change(function ()
        {

          $('.js-form').hide()

          if (this.checked)
          {

            $('#' + $(this).val() + '-form').show()

            $('#continue, .back').show()

          }

          else
          {
            $('#continue, .back').hide()
          }

        }
        ).addClass('js-ignore').trigger('change')

      },

      onChequeTerms: function ()
      {

        $('.js-cheque_terms').not('.js-ignore').change(function ()
        {

          var unchecked = $('.js-cheque_terms:not(:checked)').length

          $('#cheque-confirm').prop('disabled', 0 !== unchecked)

        }
        ).addClass('js-ignore').trigger('change')

      },

      onMiFiTerms: function ()
      {

        $('.js-mifi_terms').not('.js-ignore').change(function ()
        {

          var unchecked = $('.js-mifi_terms:not(:checked)').length

          $('#mifi-confirm').prop('disabled', 0 !== unchecked)

        }
        ).addClass('js-ignore').trigger('change')

      },

      onContinue: function ()
      {

        $('#continue').not('.js-ignore').click(function ()
        {

          if ('ok' == $('.js-service:checked').val())
          {
            $('#mifi-confirm').trigger('click')
          }

          else
          {

            $('#page1').hide()
  
            $('#page2').show()

          }

        }
        ).addClass('js-ignore')

      },

      onBack: function ()
      {

        $('.back').not('.js-ignore').click(function ()
        {

          $('#page2').hide()

          $('#page1').show()

        }
        ).addClass('js-ignore')

      }

    }

  }